// import React from 'react'
import DashboardWrapper from '../../DashboardWrapper/DashboardWrapper';
import './dashboardNotification.css';
import doctorImg from '../../../../images/notification/doctor.png'
import patientImg from '../../../../images/notification/ins.png'

import React, { useState } from "react";

export default function DashboardNotification() {

 const userInfo=JSON.parse(sessionStorage.getItem('userInfo'))
 const chatImg=()=>{
  return userInfo.entrant==='admin' ? patientImg : doctorImg 
 } 
const chatEmail =()=>{
 return userInfo.entrant==='admin' ? userInfo.email : ""
} 


const initialData = [
  { name: "khan", age: 20, title: "manager" },
  { name: "John", age: 25, title: "developer" },
  { name: "Alice", age: 30, title: "designer" },
  // Add more objects here
];

const [data, setData] = useState(initialData);
  const [searchQuery, setSearchQuery] = useState("");


  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    setSearchQuery(query);

    const filteredData = initialData.filter((item) => {
      for (const key in item) {
        if (item[key].toString().toLowerCase().includes(query)) {
          return true;
        }
      }
      return false;
    });

    setData(filteredData);
  };


 return (
  <DashboardWrapper>


<div>
      <h1>Checkbox List with Search (React)</h1>
      <input
        type="text"
        placeholder="Search"
        value={searchQuery}
        onChange={handleSearch}
      />
      <ul>
        {data.map((item, index) => (
          <li key={index}>
            <label>
              <input type="checkbox" value={item.name} />
              {item.name}, {item.age}, {item.title}
            </label>
          </li>
        ))}
      </ul>
    </div>
  
    <div className="row">
   
      {Array(6).fill().map(()=>
       <div className="col-md-4">
        <div className="mt-5 d-flex align-items-center">
          <img src={chatImg()} alt="" width="50"/>
          <div className="chat_box">
          <span>{chatEmail()}</span><br/>
          <span>{new Date().toLocaleTimeString() +' '+new Date().toLocaleDateString() }</span>
           <p>Lorem, ipsum dolor sit anventoiquam?</p>
           <div className="d-flex justify-content-between">
           <i class="fas fa-reply" title="Reply"></i>
           <i class="far fa-heart"></i>
           <i class="far fa-thumbs-up"></i>
           </div>
          
          </div>     
        </div>
      </div>
      ) }
    </div>


 </DashboardWrapper>
 )
}
